import { render } from "./rep040.vue?vue&type=template&id=1a6a6d25"
import script from "./rep040.vue?vue&type=script&lang=js"
export * from "./rep040.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__